import React from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import {
  ControlLabel,
} from 'react-bootstrap';

import { routerProps } from '../../../propTypes';

const propTypes = exact({
  errorMessage: PropTypes.array.isRequired,
  ...routerProps,
});


const ErrorPage = (props) => {
  const { errorMessage } = props;
  return (
    <ControlLabel>{errorMessage}</ControlLabel>
  );
};


ErrorPage.propTypes = propTypes;

export default ErrorPage;
